import React, { useMemo } from "react";

import BHMS_GENERATOR from "./BHMS_GENERATOR";
import { BhmsConfigType, getBhmsInfo, BHMS_STATION_CONFIG_MAP } from "./bhms_config";

const BhmsWrapper: React.FC<any> = ({ state }) => {
  const parsed_data = useMemo(() => {
    const final_data = [];
    for (const device of state.data) {
      const device_data = { ...device };
      for (const key in device_data) {
        if (!key.startsWith("B")) continue;
        const merged_data_key = key as keyof typeof device_data;
        if (device_data[merged_data_key] && Number(device_data[merged_data_key])) {
          device_data[merged_data_key] = (Number(device_data[merged_data_key]) / 1000).toFixed(3).toString();
        }
      }
      final_data.push(device_data);
    }
    return final_data;
  }, [state.data]);

  return (
    <>
      {parsed_data.map((device_data) => (
        <BhmsGridWrapper data={device_data} />
      ))}
    </>
  );
};



interface BhmsGridWrapperProps {
  data: Record<string, string>;
}
const BhmsGridWrapper: React.FC<BhmsGridWrapperProps> = ({ data }) => {
  const { STN } = data;
  const config_type =
    STN in BHMS_STATION_CONFIG_MAP
      ? BHMS_STATION_CONFIG_MAP[STN as keyof typeof BHMS_STATION_CONFIG_MAP]
      : BhmsConfigType.grid;
  const { info, config_list } = useMemo(() => getBhmsInfo(config_type, data), [config_type, data]);
  return <BhmsGrid data={data} bhms_info={info} config_list={config_list} />;
};

interface BhmsGridProps extends BhmsGridWrapperProps {
  bhms_info: { title: string; text: string | number }[];
  config_list: Record<string, any>[];
}

const BhmsGrid: React.FC<BhmsGridProps> = ({ bhms_info, data, config_list }) => {
  return (
    <div className="bhms-page">
      <div className="bhms-info" style={{ flexBasis: "20rem" }}>
        {bhms_info.map((info) => (
          <div>
            <div className="bhms-heading-bold">{info.title}</div>
            <div>{info.text}</div>
          </div>
        ))}
      </div>
      {config_list.map((config) => (
        <BHMS_GENERATOR data={data} config={config} />
      ))}
    </div>
  );
};

export default BhmsWrapper;
